import { Amplify } from 'aws-amplify';

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_06wgdVHe7',
      userPoolClientId: '69rm7tp9qjsrt1rsohga3ne5e8',
      loginWith: {
        oauth: {
          domain: 'pastely-enterprise-users.auth.us-east-1.amazoncognito.com',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [
            process.env.NODE_ENV === 'production' 
              ? 'https://pastely.app/callback' 
              : 'http://localhost:3000/callback'
          ],
          redirectSignOut: [
            process.env.NODE_ENV === 'production' 
              ? 'https://pastely.app/' 
              : 'http://localhost:3000/'
          ],
          responseType: 'code'
        }
      }
    }
  }
};

Amplify.configure(awsConfig);

export default awsConfig;
